import { useState } from 'react';
import { getPayments } from '../api';
import { badgeClass, fmtDate, shortHash } from '../format';
import { useApi } from '../useApi';
import { Pager } from '../components/Pager';

const PAGE_SIZE = 50;

export function Payments() {
  const [page, setPage] = useState(1);
  const { data, error, loading } = useApi(() => getPayments(page, PAGE_SIZE), [page]);
  const rows = data?.data ?? [];

  return (
    <div className="admin-wrap">
      <div className="page-head">
        <h1>
          Payments<span className="dot">.</span>
        </h1>
      </div>
      {data && <p className="muted">{data.total} total</p>}
      <div className="table-wrap">
        {error ? (
          <div className="empty">{error}</div>
        ) : loading && !data ? (
          <div className="empty">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="empty">No payments yet.</div>
        ) : (
          <table className="flm">
            <thead>
              <tr>
                <th>User</th>
                <th>Amount</th>
                <th>Purpose</th>
                <th>Provider</th>
                <th>Status</th>
                <th>Memo</th>
                <th>Tx hash</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id}>
                  <td>{p.user}</td>
                  <td>
                    {p.amountTon ? `${p.amountTon} TON` : <span className="muted">{p.currency}</span>}
                  </td>
                  <td className="muted">{p.purpose}</td>
                  <td className="muted">{p.provider}</td>
                  <td>
                    <span className={badgeClass(p.status)}>{p.status}</span>
                  </td>
                  <td className="muted mono">{p.memo ?? '—'}</td>
                  <td className="muted mono" title={p.txHash ?? undefined}>
                    {shortHash(p.txHash)}
                  </td>
                  <td className="muted">{fmtDate(p.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {data && (
        <Pager page={data.page ?? page} pageSize={data.pageSize ?? PAGE_SIZE} total={data.total} loading={loading} onPage={setPage} />
      )}
    </div>
  );
}
